import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import GlobalFooter from './GlobalFooter';



const CustomCountryDropdown = ({ value, onChange, name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedCountry, setSelectedCountry] = useState(null);

    const countryCodes = [
        // North America
        { code: '+1', flag: '🇺🇸', country: 'US' },
        { code: '+1', flag: '🇨🇦', country: 'CA' },
        { code: '+52', flag: '🇲🇽', country: 'MX' },
        
        // Europe
        { code: '+44', flag: '🇬🇧', country: 'GB' },
        { code: '+33', flag: '🇫🇷', country: 'FR' },
        { code: '+49', flag: '🇩🇪', country: 'DE' },
        { code: '+39', flag: '🇮🇹', country: 'IT' },
        { code: '+34', flag: '🇪🇸', country: 'ES' },
        { code: '+31', flag: '🇳🇱', country: 'NL' },
        { code: '+32', flag: '🇧🇪', country: 'BE' },
        { code: '+41', flag: '🇨🇭', country: 'CH' },
        { code: '+43', flag: '🇦🇹', country: 'AT' },
        { code: '+45', flag: '🇩🇰', country: 'DK' },
        { code: '+46', flag: '🇸🇪', country: 'SE' },
        { code: '+47', flag: '🇳🇴', country: 'NO' },
        { code: '+358', flag: '🇫🇮', country: 'FI' },
        { code: '+48', flag: '🇵🇱', country: 'PL' },
        { code: '+420', flag: '🇨🇿', country: 'CZ' },
        { code: '+421', flag: '🇸🇰', country: 'SK' },
        { code: '+36', flag: '🇭🇺', country: 'HU' },
        { code: '+351', flag: '🇵🇹', country: 'PT' },
        { code: '+30', flag: '🇬🇷', country: 'GR' },
        { code: '+353', flag: '🇮🇪', country: 'IE' },
        { code: '+354', flag: '🇮🇸', country: 'IS' },
        { code: '+7', flag: '🇷🇺', country: 'RU' },
        { code: '+380', flag: '🇺🇦', country: 'UA' },
        { code: '+375', flag: '🇧🇾', country: 'BY' },
        { code: '+372', flag: '🇪🇪', country: 'EE' },
        { code: '+371', flag: '🇱🇻', country: 'LV' },
        { code: '+370', flag: '🇱🇹', country: 'LT' },
        { code: '+385', flag: '🇭🇷', country: 'HR' },
        { code: '+381', flag: '🇷🇸', country: 'RS' },
        { code: '+387', flag: '🇧🇦', country: 'BA' },
        { code: '+382', flag: '🇲🇪', country: 'ME' },
        { code: '+383', flag: '🇽🇰', country: 'XK' },
        { code: '+386', flag: '🇸🇮', country: 'SI' },
        { code: '+389', flag: '🇲🇰', country: 'MK' },
        { code: '+359', flag: '🇧🇬', country: 'BG' },
        { code: '+40', flag: '🇷🇴', country: 'RO' },
        { code: '+373', flag: '🇲🇩', country: 'MD' },
        { code: '+355', flag: '🇦🇱', country: 'AL' },
        { code: '+356', flag: '🇲🇹', country: 'MT' },
        { code: '+357', flag: '🇨🇾', country: 'CY' },
        { code: '+377', flag: '🇲🇨', country: 'MC' },
        { code: '+376', flag: '🇦🇩', country: 'AD' },
        { code: '+378', flag: '🇸🇲', country: 'SM' },
        { code: '+39', flag: '🇻🇦', country: 'VA' },
        { code: '+423', flag: '🇱🇮', country: 'LI' },
        { code: '+352', flag: '🇱🇺', country: 'LU' },
        
        // Asia
        { code: '+86', flag: '🇨🇳', country: 'CN' },
        { code: '+91', flag: '🇮🇳', country: 'IN' },
        { code: '+81', flag: '🇯🇵', country: 'JP' },
        { code: '+82', flag: '🇰🇷', country: 'KR' },
        { code: '+852', flag: '🇭🇰', country: 'HK' },
        { code: '+65', flag: '🇸🇬', country: 'SG' },
        { code: '+60', flag: '🇲🇾', country: 'MY' },
        { code: '+66', flag: '🇹🇭', country: 'TH' },
        { code: '+84', flag: '🇻🇳', country: 'VN' },
        { code: '+62', flag: '🇮🇩', country: 'ID' },
        { code: '+63', flag: '🇵🇭', country: 'PH' },
        { code: '+90', flag: '🇹🇷', country: 'TR' },
        { code: '+98', flag: '🇮🇷', country: 'IR' },
        { code: '+964', flag: '🇮🇶', country: 'IQ' },
        { code: '+962', flag: '🇯🇴', country: 'JO' },
        { code: '+961', flag: '🇱🇧', country: 'LB' },
        { code: '+963', flag: '🇸🇾', country: 'SY' },
        { code: '+972', flag: '🇮🇱', country: 'IL' },
        { code: '+970', flag: '🇵🇸', country: 'PS' },
        { code: '+966', flag: '🇸🇦', country: 'SA' },
        { code: '+965', flag: '🇰🇼', country: 'KW' },
        { code: '+973', flag: '🇧🇭', country: 'BH' },
        { code: '+974', flag: '🇶🇦', country: 'QA' },
        { code: '+971', flag: '🇦🇪', country: 'AE' },
        { code: '+968', flag: '🇴🇲', country: 'OM' },
        { code: '+967', flag: '🇾🇪', country: 'YE' },
        { code: '+92', flag: '🇵🇰', country: 'PK' },
        { code: '+93', flag: '🇦🇫', country: 'AF' },
        { code: '+880', flag: '🇧🇩', country: 'BD' },
        { code: '+94', flag: '🇱🇰', country: 'LK' },
        { code: '+960', flag: '🇲🇻', country: 'MV' },
        { code: '+975', flag: '🇧🇹', country: 'BT' },
        { code: '+977', flag: '🇳🇵', country: 'NP' },
        { code: '+95', flag: '🇲🇲', country: 'MM' },
        { code: '+856', flag: '🇱🇦', country: 'LA' },
        { code: '+855', flag: '🇰🇭', country: 'KH' },
        { code: '+673', flag: '🇧🇳', country: 'BN' },
        { code: '+670', flag: '🇹🇱', country: 'TL' },
        { code: '+853', flag: '🇲🇴', country: 'MO' },
        { code: '+886', flag: '🇹🇼', country: 'TW' },
        { code: '+850', flag: '🇰🇵', country: 'KP' },
        { code: '+976', flag: '🇲🇳', country: 'MN' },
        { code: '+7', flag: '🇰🇿', country: 'KZ' },
        { code: '+996', flag: '🇰🇬', country: 'KG' },
        { code: '+998', flag: '🇺🇿', country: 'UZ' },
        { code: '+993', flag: '🇹🇲', country: 'TM' },
        { code: '+992', flag: '🇹🇯', country: 'TJ' },
        { code: '+994', flag: '🇦🇿', country: 'AZ' },
        { code: '+995', flag: '🇬🇪', country: 'GE' },
        { code: '+374', flag: '🇦🇲', country: 'AM' },
        
        // Africa
        { code: '+234', flag: '🇳🇬', country: 'NG' },
        { code: '+254', flag: '🇰🇪', country: 'KE' },
        { code: '+233', flag: '🇬🇭', country: 'GH' },
        { code: '+27', flag: '🇿🇦', country: 'ZA' },
        { code: '+20', flag: '🇪🇬', country: 'EG' },
        { code: '+212', flag: '🇲🇦', country: 'MA' },
        { code: '+216', flag: '🇹🇳', country: 'TN' },
        { code: '+213', flag: '🇩🇿', country: 'DZ' },
        { code: '+218', flag: '🇱🇾', country: 'LY' },
        { code: '+249', flag: '🇸🇩', country: 'SD' },
        { code: '+251', flag: '🇪🇹', country: 'ET' },
        { code: '+252', flag: '🇸🇴', country: 'SO' },
        { code: '+253', flag: '🇩🇯', country: 'DJ' },
        { code: '+291', flag: '🇪🇷', country: 'ER' },
        { code: '+256', flag: '🇺🇬', country: 'UG' },
        { code: '+255', flag: '🇹🇿', country: 'TZ' },
        { code: '+250', flag: '🇷🇼', country: 'RW' },
        { code: '+257', flag: '🇧🇮', country: 'BI' },
        { code: '+243', flag: '🇨🇩', country: 'CD' },
        { code: '+242', flag: '🇨🇬', country: 'CG' },
        { code: '+236', flag: '🇨🇫', country: 'CF' },
        { code: '+237', flag: '🇨🇲', country: 'CM' },
        { code: '+235', flag: '🇹🇩', country: 'TD' },
        { code: '+240', flag: '🇬🇶', country: 'GQ' },
        { code: '+241', flag: '🇬🇦', country: 'GA' },
        { code: '+239', flag: '🇸🇹', country: 'ST' },
        { code: '+238', flag: '🇨🇻', country: 'CV' },
        { code: '+221', flag: '🇸🇳', country: 'SN' },
        { code: '+220', flag: '🇬🇲', country: 'GM' },
        { code: '+224', flag: '🇬🇳', country: 'GN' },
        { code: '+245', flag: '🇬🇼', country: 'GW' },
        { code: '+232', flag: '🇸🇱', country: 'SL' },
        { code: '+231', flag: '🇱🇷', country: 'LR' },
        { code: '+225', flag: '🇨🇮', country: 'CI' },
        { code: '+226', flag: '🇧🇫', country: 'BF' },
        { code: '+223', flag: '🇲🇱', country: 'ML' },
        { code: '+227', flag: '🇳🇪', country: 'NE' },
        { code: '+229', flag: '🇧🇯', country: 'BJ' },
        { code: '+228', flag: '🇹🇬', country: 'TG' },
        { code: '+230', flag: '🇲🇺', country: 'MU' },
        { code: '+248', flag: '🇸🇨', country: 'SC' },
        { code: '+261', flag: '🇲🇬', country: 'MG' },
        { code: '+269', flag: '🇰🇲', country: 'KM' },
        { code: '+262', flag: '🇷🇪', country: 'RE' },
        { code: '+290', flag: '🇸🇭', country: 'SH' },
        { code: '+222', flag: '🇲🇷', country: 'MR' },
        { code: '+267', flag: '🇧🇼', country: 'BW' },
        { code: '+264', flag: '🇳🇦', country: 'NA' },
        { code: '+268', flag: '🇸🇿', country: 'SZ' },
        { code: '+266', flag: '🇱🇸', country: 'LS' },
        { code: '+260', flag: '🇿🇲', country: 'ZM' },
        { code: '+263', flag: '🇿🇼', country: 'ZW' },
        { code: '+265', flag: '🇲🇼', country: 'MW' },
        { code: '+258', flag: '🇲🇿', country: 'MZ' },
        { code: '+244', flag: '🇦🇴', country: 'AO' },
        
        // Oceania
        { code: '+61', flag: '🇦🇺', country: 'AU' },
        { code: '+64', flag: '🇳🇿', country: 'NZ' },
        { code: '+679', flag: '🇫🇯', country: 'FJ' },
        { code: '+687', flag: '🇳🇨', country: 'NC' },
        { code: '+689', flag: '🇵🇫', country: 'PF' },
        { code: '+685', flag: '🇼🇸', country: 'WS' },
        { code: '+676', flag: '🇹🇴', country: 'TO' },
        { code: '+678', flag: '🇻🇺', country: 'VU' },
        { code: '+686', flag: '🇰🇮', country: 'KI' },
        { code: '+677', flag: '🇸🇧', country: 'SB' },
        { code: '+683', flag: '🇳🇺', country: 'NU' },
        { code: '+684', flag: '🇦🇸', country: 'AS' },
        { code: '+682', flag: '🇨🇰', country: 'CK' },
        { code: '+691', flag: '🇫🇲', country: 'FM' },
        { code: '+692', flag: '🇲🇭', country: 'MH' },
        { code: '+680', flag: '🇵🇼', country: 'PW' },
        { code: '+675', flag: '🇵🇬', country: 'PG' },
        { code: '+688', flag: '🇹🇻', country: 'TV' },
        { code: '+674', flag: '🇳🇷', country: 'NR' },
        
        // South America
        { code: '+55', flag: '🇧🇷', country: 'BR' },
        { code: '+54', flag: '🇦🇷', country: 'AR' },
        { code: '+56', flag: '🇨🇱', country: 'CL' },
        { code: '+57', flag: '🇨🇴', country: 'CO' },
        { code: '+51', flag: '🇵🇪', country: 'PE' },
        { code: '+58', flag: '🇻🇪', country: 'VE' },
        { code: '+595', flag: '🇵🇾', country: 'PY' },
        { code: '+598', flag: '🇺🇾', country: 'UY' },
        { code: '+597', flag: '🇸🇷', country: 'SR' },
        { code: '+592', flag: '🇬🇾', country: 'GY' },
        { code: '+593', flag: '🇪🇨', country: 'EC' },
        { code: '+591', flag: '🇧🇴', country: 'BO' },
        { code: '+594', flag: '🇬🇫', country: 'GF' },
        { code: '+500', flag: '🇫🇰', country: 'FK' },
        
        // Central America & Caribbean
        { code: '+1876', flag: '🇯🇲', country: 'JM' },
        { code: '+1809', flag: '🇩🇴', country: 'DO' },
        { code: '+1829', flag: '🇩🇴', country: 'DO' },
        { code: '+1849', flag: '🇩🇴', country: 'DO' },
        { code: '+53', flag: '🇨🇺', country: 'CU' },
        { code: '+509', flag: '🇭🇹', country: 'HT' },
        { code: '+1787', flag: '🇵🇷', country: 'PR' },
        { code: '+1939', flag: '🇵🇷', country: 'PR' },
        { code: '+1242', flag: '🇧🇸', country: 'BS' },
        { code: '+1246', flag: '🇧🇧', country: 'BB' },
        { code: '+1268', flag: '🇦🇬', country: 'AG' },
        { code: '+1284', flag: '🇻🇬', country: 'VG' },
        { code: '+1340', flag: '🇻🇮', country: 'VI' },
        { code: '+1345', flag: '🇰🇾', country: 'KY' },
        { code: '+1441', flag: '🇧🇲', country: 'BM' },
        { code: '+1473', flag: '🇬🇩', country: 'GD' },
        { code: '+1649', flag: '🇹🇨', country: 'TC' },
        { code: '+1664', flag: '🇲🇸', country: 'MS' },
        { code: '+1670', flag: '🇲🇵', country: 'MP' },
        { code: '+1671', flag: '🇬🇺', country: 'GU' },
        { code: '+1684', flag: '🇦🇸', country: 'AS' },
        { code: '+1721', flag: '🇸🇽', country: 'SX' },
        { code: '+1758', flag: '🇱🇨', country: 'LC' },
        { code: '+1767', flag: '🇩🇲', country: 'DM' },
        { code: '+1784', flag: '🇻🇨', country: 'VC' },
        { code: '+1868', flag: '🇹🇹', country: 'TT' },
        { code: '+1869', flag: '🇰🇳', country: 'KN' },
        { code: '+502', flag: '🇬🇹', country: 'GT' },
        { code: '+503', flag: '🇸🇻', country: 'SV' },
        { code: '+504', flag: '🇭🇳', country: 'HN' },
        { code: '+505', flag: '🇳🇮', country: 'NI' },
        { code: '+506', flag: '🇨🇷', country: 'CR' },
        { code: '+507', flag: '🇵🇦', country: 'PA' },
        { code: '+508', flag: '🇵🇲', country: 'PM' },
        { code: '+590', flag: '🇬🇵', country: 'GP' },
        { code: '+596', flag: '🇲🇶', country: 'MQ' },
        { code: '+599', flag: '🇧🇶', country: 'BQ' },
        { code: '+599', flag: '🇨🇼', country: 'CW' },
        { code: '+297', flag: '🇦🇼', country: 'AW' },
        { code: '+1264', flag: '🇦🇮', country: 'AI' },
        { code: '+501', flag: '🇧🇿', country: 'BZ' }
      ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (country) => {
        onChange({
            target: {
                name: name,
                value: country.code
            }
        });
        setSelectedCountry(country);
        setIsOpen(false);
    };

    // Initialize selected country
    useEffect(() => {
        if (!selectedCountry) {
            setSelectedCountry(countryCodes[0]); // Default to first country
        }
    }, []);

    return (
        <div className="custom-dropdown-container" ref={dropdownRef}>
            <div 
                className="custom-dropdown-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="selected-country">
                    {selectedCountry?.flag} {selectedCountry?.code}
                </span>
                <svg 
                    className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2"
                >
                    <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
            </div>
            
            {isOpen && (
                <div className="custom-dropdown-menu">
                    {countryCodes.map((country) => (
                        <div
                            key={country.country}  // Use country code as key
                            className={`dropdown-option ${selectedCountry?.country === country.country ? 'selected' : ''}`}
                            onClick={() => handleSelect(country)}
                        >
                            <span>{country.flag} {country.code}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};


function PaymentInformation() {
    const record = JSON.parse(localStorage.getItem("auth"));
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        phoneCode: '+1',
        phoneNumber: '',
        fullName: '' // Added fullName to state
    });

    const [error, setError] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');

    // console.log("record: ", record.avatar);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === 'phoneNumber') {

            // Check for leading zero
            if (value.startsWith('0')) {
                setErrorMessage('Phone number should not start with 0');
  
                // Automatically hide error after 3 seconds
                setTimeout(() => {
                    setErrorMessage('');
                }, 2000);
            }

            // Remove leading zeros
            updatedValue = value.replace(/^0+/, '');
        }
        setFormData({
            ...formData,
            [name]: updatedValue
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const combinedPhoneNumber = formData.phoneCode.replace('+', '') + formData.phoneNumber;

        const data = {
            phoneNumber: combinedPhoneNumber,
            fullName: formData.fullName // Include fullName in payload
        };
        // console.log("data: ",data)
        try {
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/verify-phone";
            const res = await axios.post(url, data);
            console.log("response Data: ", res.data);
            const payload = res.data;
            setIsLoading(false);
            localStorage.setItem("phone", formData.phoneNumber);
            localStorage.setItem("fullName", formData.fullName);
            navigate('/pages/verify-phone', { state: { payload } });
        } catch (err) {
            setIsLoading(false);
            setError(true);
            console.log("error", err);
            const expectedError = err?.response;
            if (expectedError) {
                const errorMessage = err?.response?.data?.message || "You’ve entered a wrong verification code, please retry.";
                setErrorMessage(errorMessage);
            } else {
                setErrorMessage("Unable to verify code");
            }

            // Clear error after 2 seconds
            setTimeout(() => {
                setErrorMessage('');
            }, 2000);
        }
    };

    const isPhoneNumberEntered = formData.phoneNumber.trim().length > 0;
    const isFullNameEntered = formData.fullName.trim().length > 0;

    return (
        <div className='global_layout'>
            

            <div className='global_container'>
                <div className='top_bar'></div>

                <div className='global_content'>
                    <div className='glob_avater'>
                        {
                            record?.avatar ?
                            
                            <img className='img_avater' src={record?.avatar} alt=''/>:
                            
                            <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0,1)}</p>
                        }
                    </div>
                    <p className='glob_title'>Payment information</p>
                    <p className='glob_desc'>Your data is encrypted and your details will not be accessible to Superwallet</p>
                    <div className='amount_content'>
                        <div className='name_amount'>
                            <img src='/images/global/briefcase.svg' alt='' />
                            <p className='glob_name'>Name</p>
                        </div>
                        <h6 className='name_value'>{record?.data?.business_name}</h6>
                    </div>
                    <div className='amount_pattern'>
                        <p className='glob_name' style={{ marginTop: "10px" }}>Amount</p>
                        <p className='glob_amount_value'>{record?.payableFxAmountString}</p>
                    </div>
                    <form className='glob_form' onSubmit={handleSubmit}>
                        {/* Full Name */}
                        <div className='form_group'>
                            <div style={{ display: "flex" }}>
                                <p className='glob_name'>Full Name</p>
                                <img src='/images/global/asterisk.svg' alt='' />
                            </div>
                            <input
                                className='input_field'
                                type='text'
                                placeholder='Enter your full name'
                                name='fullName'
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                       
                        {/* Phone Number */}
                        <div className='phone_container'>
                            <div style={{ display: "flex" }}>
                                <p className='glob_name'>Phone</p>
                                <img src='/images/global/asterisk.svg' alt='' />
                            </div>
                            <div className='input_select_phones' style={{ marginTop: "6px" }}>
                                <CustomCountryDropdown
                                    value={formData.phoneCode}
                                    onChange={handleChange}
                                    name="phoneCode"
                                />
                                
                                <div className="phone-separators"></div>
                                
                                <input
                                    className='input_phones'
                                    type='number'
                                    placeholder='00 0000 0000'
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            {errorMessage && (
                                <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>{errorMessage}</p>
                            )}
                        </div>

                        <p className='instruction_text' style={{ marginTop: "18px" }}>By selecting “Continue” you agree to the </p>
                        <h5 className='flick_privacy'>Flick End User Privacy Policy</h5>
                        <button
                            disabled={!isPhoneNumberEntered || !isFullNameEntered || isLoading}
                            className={`${!isPhoneNumberEntered || !isFullNameEntered || isLoading ? 'unactive' : 'globalBtn'}`}
                            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "18px", gap: "8px" }}
                        >
                            {isLoading ? (
                                <BeatLoader
                                    color="#FFF"
                                    cssOverride={{}}
                                />
                            ) : (
                                <>
                                    <p>Proceed</p>
                                    {
                                        !isPhoneNumberEntered || !isFullNameEntered || isLoading ?
                                            <img src='/images/global/inactive.svg' alt='' /> :
                                            <img src='/images/global/activeArrow.svg' alt='' />
                                    }
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>

            {
            !record?.total_whitelabelling &&
            <GlobalFooter />
            }
        </div>
    );
}

export default PaymentInformation;
